import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import { useEffect } from "react";
import WaterUnitInfoComponent from "./waterUnitInfoComponent";

const WaterUnitInfoCheckModal = ({ isOpen, onClose, unit }: any) => {

    useEffect(() => { console.log(unit) }, [])

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="5xl"
            shouldBlockScroll={true}
            isDismissable={true}
            scrollBehavior="inside"
            backdrop="blur"
            className="p-8"
        >
            <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
                <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
                    <p>{unit.id} - Waterhuishouding</p>
                </ModalHeader>
                <ModalBody className="px-0">
                    <WaterUnitInfoComponent
                        waterSystemInfo={{ ...unit?.waterUnitInfo, unitId: unit.id}}
                        handleCloseParent={onClose}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default WaterUnitInfoCheckModal;
